<template>
    <!--    <a @click="pushToProduct" :class="productFieldObject.moduleId" class="recommendation-product-field">
        <div class="recommendation-product-field-content">
            <app-icon class="mr-1" :icon="productFieldObject.moduleId" size-px="96px" />
            <div>
                <h2>
                    {{ productFieldObject.headline }}
                </h2>
                <p>
                    {{ productFieldObject.subline }}
                </p>
            </div>
            <app-icon class="goto__icon" icon="goto" size-px="24px" />
        </div>
    </a>-->
    <a @click="pushToProduct" :class="productFieldObject.moduleId" class="recommendation-product-field">
        <div class="columns is-vcentered">
            <div class="column is-narrow is-hidden-mobile is-paddingless">
                <app-icon :icon="productFieldObject.moduleId" size-px="112px" />
            </div>
            <div class="column">
                <h2>
                    {{ productFieldObject.headline }}
                </h2>
                <p>
                    {{ productFieldObject.subline }}
                </p>
                <p
                    v-if="!!getProbability && (getProbability.probability * 100).toFixed(0) >= 20"
                    class="italic-text is-light"
                >
                    <strong>{{ (getProbability.probability * 100).toFixed(0) }} <small>%</small></strong>
                    {{ textMapper(productFieldObject.id) }}
                </p>
                <!-- UPDATE: 04-02-2021 Remove "viele" text
                <p
                    v-else-if="!!getProbability && (getProbability.probability * 100).toFixed(0) >= 10"
                    class="italic-text is-light"
                >
                    Viele
                    {{ textMapper(productFieldObject.id) }}
                </p>
                -->
            </div>
            <div class="column is-narrow is-hidden-mobile">
                <app-icon class="goto__icon" icon="goto" size-px="24px" />
            </div>
        </div>
    </a>
</template>

<script>
import AppIcon from '@/components/AppIcon';
import { mapGetters } from 'vuex';
export default {
    name: 'RecommendationsProductField',
    components: { AppIcon },
    props: {
        productField: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            productFieldObject: null,
        };
    },
    computed: {
        ...mapGetters({
            getProductField: 'getProductField',
            probability: 'recommendation/getProductProbabilities',
        }),
        getProbability() {
            let probability = null;
            this.probability.filter((entry) => {
                if (entry.code.toLowerCase() === this.productFieldObject.id.toLowerCase()) {
                    probability = entry;
                }
            });

            return probability;
        },
    },
    created() {
        this.productFieldObject = this.getProductField(this.productField);
    },
    methods: {
        pushToProduct() {
            this.$matomo &&
                this.$matomo.trackEvent('Click', 'Bankempfehlung-Produktfeldempfehlung', this.productFieldObject.id);
            this.$store.commit('UPDATE_CURRENTLY_OPEN_PRODUCTLIST', this.productField);
            this.$router.push({
                name: 'module',
                params: {
                    module: this.productFieldObject.moduleId,
                },
            });
        },
        textMapper(text) {
            if (text === 'Liquiditaet_Girokonto') {
                return 'der Kunden mit ähnlicher Versorgung haben auch ein Girokonto.';
            }
            if (text === 'Liquiditaet_Kreditkarteeasycredit') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine Kreditkarte oder einen easyCredit.';
            }
            if (text === 'Liquiditaet_BankingApp') {
                return 'der Kunden mit ähnlicher Versorgung nutzen auch die MobileApp.';
            }
            if (text === 'Absicherung_Sachversicherung') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine Sachversicherung.';
            }
            if (text === 'Absicherung_Einkommensversicherung') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine Einkommensversicherung.';
            }
            if (text === 'Absicherung_Krankenversicherung') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine Krankenvoll- oder -zusatzversicherung.';
            }
            if (text === 'Vermoegen_Bankeinlagen') {
                return 'der Kunden mit ähnlicher Versorgung verfügen auch über einen Finanzpuffer.';
            }
            if (text === 'Vermoegen_Sparplan') {
                return 'der Kunden mit ähnlicher Versorgung haben auch einen Fondssparplan.';
            }
            if (text === 'Vermoegen_Depot') {
                return 'der Kunden mit ähnlicher Versorgung haben auch ein Depot.';
            }
            if (text === 'Vorsorge_Bausparvertrag') {
                return 'der Kunden mit ähnlicher Versorgung haben auch einen Bausparvertrag.';
            }
            if (text === 'Vorsorge_StaatlichbAV') {
                return 'der Kunden mit ähnlicher Versorgung nutzen auch staatliche Zuschüsse bei der Altersvorsorge.';
            }
            if (text === 'Vorsorge_pAV') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine private Altersvorsorge.';
            }
            if (text === 'Immobilie_Finanzierung') {
                return 'der Kunden mit ähnlicher Versorgung haben auch eine Baufinanzierung.';
            }
            if (text === 'Extra_Kontoauszug') {
                return 'der Kunden mit ähnlicher Versorgung nutzen auch das elektronische Postfach.';
            }
            return 'der Kunden mit ähnlicher Versorgung nutzen auch dieses Produkt.';
        },
    },
};
</script>
